import { Routes } from "@angular/router";
import {
  ACCUEIL,
  MAINTENANCE,
  AUTHENTIFICATION_FORTE,
  CONDITIONS_GENERALES,
  CONNEXION,
  CONTRACTDETAILS,
  CONTRACTDETAILS_PARTNER,
  CONTRACTDETAILS_PARTNER_WITHOUT_BRAND,
  MENTIONS_LEGALES,
  MON_PROFIL,
  MOT_DE_PASSE_OUBLIE,
  NOS_OFFRES,
  NOUS_CONTACTER,
  PAGE_NON_TROUVEE,
  PAYMENT_REQUEST,
  PREMIERE_CONNEXION,
  QUOTATIONDETAILS,
  RECEIPTSDETAIL,
  REDIRECTION_UTILISATEUR,
  REGULARISATION_OFF,
  REGULARISATION_ON,
  REINITIALISATION_MOT_DE_PASSE,
  STORED_DOCUMENTS,
} from "./shared/constants/route.constants";
import { authGuard } from "./shared/guards/auth.guard";
import { brandGuard } from "./shared/guards/brand.guard";
import { ContactUsComponent } from "./views/contact-us/contact-us.component";
import { ContractDetailComponent } from "./views/contract-detail/contract-detail.component";
import { DetailContratRedirectComponent } from "./views/contract-detail/contract-detail-redirect.component";
import { HomeComponent } from "./views/home/home.component";
import { LegalNoticeComponent } from "./views/legal-notice/legal-notice.component";
import { LoginComponent } from "./views/login/login.component";
import { OffersComponent } from "./views/offers/offers.component";
import { PageNotFoundComponent } from "./views/page-not-found/page-not-found.component";
import { PasswordForgottenComponent } from "./views/password-forgotten/password-forgotten.component";
import { PasswordInitComponent } from "./views/password-init/password-init.component";
import { PasswordResetComponent } from "./views/password-reset/password-reset.component";
import { PaymentRequestComponent } from "./views/payment-request/payment-request.component";
import { QuotationDetailsComponent } from "./views/quotation-detail/quotation-detail.component";
import { ReceiptsDetailComponent } from "./views/receipts-detail/receipts-detail.component";
import { RegularisationScheduleComponent } from "./views/regularisation-schedule/regularisation-schedule.component";
import { StoredDocumentsComponent } from "./views/stored-documents/stored-documents.component";
import { StrongAuthenticationComponent } from "./views/strong-authentication/strong-authentication.component";
import { TermsAndConditionsComponent } from "./views/terms-and-conditions/terms-and-conditions.component";
import { UserProfileComponent } from "./views/user-profile/user-profile.component";
import { UserRedirectComponent } from "./views/user-redirect/user-redirect.component";
import { MaintenanceComponent } from "./views/maintenance/maintenance";

export const routes: Routes = [
  {
    path: MAINTENANCE,
    component: MaintenanceComponent,
  },
  {
    path: REDIRECTION_UTILISATEUR,
    component: UserRedirectComponent,
    canActivate: [brandGuard],
  },
  {
    path: REINITIALISATION_MOT_DE_PASSE,
    component: PasswordResetComponent,
    canActivate: [brandGuard],
  },
  {
    path: CONNEXION,
    component: LoginComponent,
    canActivate: [brandGuard],
  },
  {
    path: PREMIERE_CONNEXION,
    component: PasswordInitComponent,
    canActivate: [brandGuard],
  },
  {
    path: MOT_DE_PASSE_OUBLIE,
    component: PasswordForgottenComponent,
    canActivate: [brandGuard],
  },
  {
    path: AUTHENTIFICATION_FORTE,
    component: StrongAuthenticationComponent,
    canActivate: [brandGuard],
  },
  {
    path: MENTIONS_LEGALES,
    component: LegalNoticeComponent,
    canActivate: [brandGuard],
  },
  {
    path: CONDITIONS_GENERALES,
    component: TermsAndConditionsComponent,
    canActivate: [brandGuard],
  },
  {
    path: ACCUEIL,
    component: HomeComponent,
    canActivate: [brandGuard, authGuard],
  },
  {
    path: MON_PROFIL,
    component: UserProfileComponent,
    canActivate: [brandGuard, authGuard],
  },
  {
    path: PAGE_NON_TROUVEE,
    component: PageNotFoundComponent,
  },
  {
    path: NOUS_CONTACTER,
    component: ContactUsComponent,
    canActivate: [brandGuard, authGuard],
  },
  {
    path: NOS_OFFRES,
    component: OffersComponent,
    canActivate: [brandGuard, authGuard],
  },
  {
    path: QUOTATIONDETAILS,
    component: QuotationDetailsComponent,
    canActivate: [brandGuard, authGuard],
  },
  {
    path: CONTRACTDETAILS,
    component: ContractDetailComponent,
    canActivate: [brandGuard, authGuard],
  },
  {
    path: CONTRACTDETAILS_PARTNER,
    component: DetailContratRedirectComponent,
    canActivate: [brandGuard, authGuard],
  },
  {
    path: CONTRACTDETAILS_PARTNER_WITHOUT_BRAND,
    component: DetailContratRedirectComponent,
    canActivate: [brandGuard, authGuard],
  },
  {
    path: RECEIPTSDETAIL,
    component: ReceiptsDetailComponent,
    canActivate: [brandGuard, authGuard],
  },
  {
    path: STORED_DOCUMENTS,
    component: StoredDocumentsComponent,
    canActivate: [brandGuard, authGuard],
  },
  {
    path: REGULARISATION_OFF,
    component: RegularisationScheduleComponent,
    canActivate: [brandGuard],
  },
  {
    path: PAYMENT_REQUEST,
    component: PaymentRequestComponent,
    canActivate: [brandGuard],
  },
  {
    path: REGULARISATION_ON,
    component: RegularisationScheduleComponent,
    canActivate: [brandGuard, authGuard],
  },
  { path: "", redirectTo: ACCUEIL, pathMatch: "full" },
  {
    path: "**",
    pathMatch: "full",
    redirectTo: PAGE_NON_TROUVEE,
  },
];
